import { FaLaptop, FaTv, FaUps, FaFileContract } from 'react-icons/fa';
import { LuComputer, LuMicrowave } from 'react-icons/lu';
import { BiMoneyWithdraw } from 'react-icons/bi';
import { SiAnydesk } from 'react-icons/si';
import { GiBuyCard } from 'react-icons/gi';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom'; // Importe o Link do react-router-dom

const ServicesSection = () => {
  const services = [
    { 
      icon: <FaLaptop className="w-8 h-8 mx-auto" />, 
      title: 'Notebook', 
      description: 'Consertos de placa, tela, teclado, formatação e upgrades.',
      path: '/servicos/notebook' // Caminho relativo
    },
    { 
      icon: <LuComputer className="w-8 h-8 mx-auto" />,
      title: 'PC', 
      description: 'Manutenção preventiva, upgrades, montagem personalizada e redes.',
      path: '/servicos/pc'
    },
    { 
      icon: <FaTv className="w-8 h-8 mx-auto" />,
      title: 'TV', 
      description: 'Reparo de imagem, som, placas e conectividade em todas as marcas.',
      path: '/servicos/tv'
    },
    { 
      icon: <LuMicrowave className="w-8 h-8 mx-auto" />,
      title: 'Microondas', 
      description: 'Reparo e manutenção de microondas de todas as marcas.',
      path: '/servicos/microondas'
    },
    { 
      icon: <FaUps className="w-8 h-8 mx-auto" />,
      title: 'No-breaks', 
      description: 'Manutenção e reparo de no-breaks para garantir energia ininterrupta.',
      path: '/servicos/nobreaks'
    },
    { 
      icon: <BiMoneyWithdraw className="w-8 h-8 mx-auto" />,
      title: 'Orçamento Grátis', 
      description: 'Orçamento grátis sem compromisso para qualquer serviço.',
      path: '/servicos/orcamento'
    },
    { 
      icon: <FaFileContract className="w-8 h-8 mx-auto" />,
      title: 'Contrato', 
      description: 'Contrato de Manutenção para reduzir custos com visitas técnicas.',
      path: '/servicos/contrato'
    },
    { 
      icon: <SiAnydesk className="w-8 h-8 mx-auto" />,
      title: 'Atendimento Remoto', 
      description: 'Suporte remoto para resolver problemas de software rapidamente.',
      path: '/servicos/atendimento-remoto'
    },
    { 
      icon: <GiBuyCard className="w-8 h-8 mx-auto" />,
      title: 'Venda de Peças', 
      description: 'Peças e componentes de qualidade para upgrades e substituições.',
      path: '/servicos/venda-pecas'
    },
  ];

  return (
    <section className="section-padding surface-muted">
      <div className="container-responsive">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-2xl xs:text-3xl xs2:text-3xl xs3:text-4xl sm:text-4xl 
                   md:text-5xl lg:text-6xl font-bold mb-6 xs:mb-8 sm:mb-10 md:mb-12 
                   text-center text-gray-800 dark:text-gray-100"
        >
          Nossos Serviços
          <div className="w-16 xs:w-20 sm:w-24 md:w-32 h-0.5 xs:h-1 bg-primary-600 
                        mx-auto mt-3 xs:mt-4 sm:mt-5 rounded-full"></div>
        </motion.h2>
        
        <div className="grid grid-cols-1 xs4:grid-cols-2 sm:grid-cols-2 
                       lg:grid-cols-3 gap-4 xs:gap-5 xs2:gap-6 sm:gap-6 md:gap-8 
                       lg:gap-10 max-w-7xl mx-auto">
          {services.map((service, index) => (
            <motion.div
              key={service.path}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              whileHover={{ y: -8, transition: { duration: 0.2 } }}
              transition={{ 
                duration: 0.4, 
                delay: index * 0.1,
                type: "spring",
                stiffness: 100
              }}
              viewport={{ once: true, margin: "-50px" }}
              className="card-modern group cursor-pointer"
            >
              {/* Ícone com gradiente e animação */}
              <motion.div 
                className="w-14 h-14 xs:w-16 xs:h-16 xs2:w-18 xs2:h-18 
                          sm:w-20 sm:h-20 md:w-24 md:h-24 mx-auto mb-3 xs:mb-4 
                          sm:mb-6 flex items-center justify-center rounded-2xl
                          bg-gradient-to-br from-primary-50 to-primary-100
                          group-hover:from-primary-100 group-hover:to-primary-200
                          shadow-soft group-hover:shadow-medium
                          transition-all duration-300"
                whileHover={{ scale: 1.1, rotate: [0, -3, 3, 0] }}
                transition={{ duration: 0.4 }}
              >
                <div className="text-primary-600 group-hover:text-primary-700 
                              transition-colors duration-300 text-xl xs:text-2xl 
                              sm:text-3xl md:text-4xl">
                  {service.icon}
                </div>
              </motion.div>

              {/* Título */}
              <h3 className="text-lg xs:text-xl xs2:text-xl sm:text-2xl md:text-2xl 
                           font-bold text-gray-800 mb-2 xs:mb-3 text-center
                           group-hover:text-primary-700 transition-colors duration-300">
                {service.title}
              </h3>

              {/* Descrição */}
              <p className="text-sm xs:text-sm xs2:text-base sm:text-base md:text-lg 
                          text-gray-600 mb-3 xs:mb-4 sm:mb-6 text-center">
                {service.description}
              </p>

              {/* Link */}
              <Link 
                to={service.path}
                className="flex items-center justify-center gap-2 text-primary-600 
                          font-semibold hover:text-primary-700 transition-all duration-300
                          group/link text-sm xs:text-base"
              >
                <span className="relative">
                  Saiba mais
                  <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-primary-600 
                                 group-hover/link:w-full transition-all duration-300"></span>
                </span>
                <motion.span 
                  className="group-hover/link:translate-x-1 transition-transform"
                  whileHover={{ x: 3 }}
                >
                  →
                </motion.span>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
